import { Controller } from "@hotwired/stimulus";

// Closes the parent <details> on outside-click or Escape, so it acts as a dropdown.
export default class extends Controller {
  connect() {
    this.boundOutsideClick = this.handleOutsideClick.bind(this);
    this.boundEscape = this.handleEscape.bind(this);
    document.addEventListener("click", this.boundOutsideClick);
    document.addEventListener("keydown", this.boundEscape);
  }

  disconnect() {
    document.removeEventListener("click", this.boundOutsideClick);
    document.removeEventListener("keydown", this.boundEscape);
  }

  handleOutsideClick(event) {
    if (!this.element.hasAttribute("open")) return;
    if (this.element.contains(event.target)) return;
    this.element.removeAttribute("open");
  }

  handleEscape(event) {
    if (event.key !== "Escape") return;
    if (!this.element.hasAttribute("open")) return;
    this.element.removeAttribute("open");
  }
}
